export const wrapper = ({ theme }) => ({
    backgroundColor: theme.colors.greyLight,
    paddingTop: '96px',
    paddingBottom: '96px',
    width: '100%',
});

export const inner = () => ({
    maxWidth: '960px',
    margin: '0 auto',
    paddingLeft: '24px',
    paddingRight: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
    min1200px: {
        paddingLeft: 0,
        paddingRight: 0,
    },
});

export const sectionHeader = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
});

export const icon = () => ({
    flexShrink: 0,
    width: '90px',
    height: '90px',
});

export const sectionTitle = ({ theme }) => ({
    flex: '1 0 0',
    fontFamily: theme.fontFamily,
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '36px',
    color: theme.colors.black,
    textAlign: 'center',
    margin: 0,
    whiteSpace: 'nowrap',
    min768px: {
        fontSize: '34px',
        lineHeight: '42px',
    },
    min992px: {
        fontSize: '40px',
        lineHeight: '50px',
    },
});

export const list = () => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});
